
import store from '@/store'
import types from '@/store/mutation-types'

$.fn.textWidth = function (text, font, offset) {
  if (!$.fn.textWidth.fakeEl) $.fn.textWidth.fakeEl = $('<span>').hide().appendTo(document.body)
  $.fn.textWidth.fakeEl.text(text || this.val() || this.text() || this.attr('placeholder')).css('font', font || this.css('font'))
  return $.fn.textWidth.fakeEl.width() + offset
}

/** Coalesce layout-heavy textarea resizes to one rAF per element (improves INP). */
const pendingResizeTasks = new WeakMap()
let pendingResizeElementsRaf = null

function getResizeOptions (binding = {}) {
  const value = binding.value
  return value && typeof value === 'object' ? value : {}
}

export function scheduleRefreshSize (el, options = {}) {
  if (!el) {
    return
  }
  const pendingTask = pendingResizeTasks.get(el)
  if (options.defer) {
    if (pendingTask && pendingTask.timeoutId) {
      window.clearTimeout(pendingTask.timeoutId)
    } else if (pendingTask) {
      return
    }
    const delay = typeof options.delay === 'number' && options.delay >= 0 ? options.delay : 120
    const timeoutId = window.setTimeout(() => {
      pendingResizeTasks.delete(el)
      utils.refreshsize(el)
    }, delay)
    pendingResizeTasks.set(el, { timeoutId })
    return
  }
  if (pendingTask) {
    return
  }
  const rafId = window.requestAnimationFrame(() => {
    pendingResizeTasks.delete(el)
    utils.refreshsize(el)
  })
  pendingResizeTasks.set(el, { rafId })
}

export const utils = {
  findVModelName (vnode) {
    return (vnode.data.directives.find(function (o) {
      return o.name === 'model'
    }) || {}).expression
  },
  setVModelValueIfExist (value, vnode) {
    const expression = this.findVModelName(vnode)
    if (expression) {
      vnode.context[expression] = value
    }
  },
  setDirty (src = '') {
    store.commit(`form/${types.FORM_UPDATE}`, { isDirty: true, src })
  },
  resetDirty (src = '') {
    store.commit(`form/${types.FORM_UPDATE}`, { isDirty: false, src })
  },
  getDirty () {
    return store.getters['form/isPageDirty']
  },
  autoresize (el = {}) {
    const height = (el.offsetHeight - el.clientHeight + el.scrollHeight) || 40
    $(el).css('height', 'auto').css('height', height < 40 ? 40 : height)
  },
  refreshsize (el = {}) {
    const docTop = (document.documentElement && document.documentElement.scrollTop) || window.pageYOffset
    $(el).css('height', 40)
    utils.autoresize(el)
    if (docTop) {
      document.documentElement.scrollTop = docTop
    }
  },
  resizeElements () {
    if (pendingResizeElementsRaf) {
      return
    }
    pendingResizeElementsRaf = window.requestAnimationFrame(() => {
      pendingResizeElementsRaf = null
      const els = document.getElementsByClassName('autosize')
      for (let i = 0; i < els.length; i += 1) {
        utils.checkVisibility(els.item(i))
      }
    })
  },
  checkVisibility (el) {
    var visiblePositions = el.getBoundingClientRect()
    if (visiblePositions.top > 0) {
      utils.autoresize(el)
    }
  },
}

const InputChange = {
  install (Vue, options) {
    Vue.directive('hkldinput', {
      bind: function (el, binding) {
        if (!(binding.value && binding.value.unchecked)) {
          el.addEventListener('change', function (event) {
            utils.setDirty(deep(binding, 'value.component'))
            if (el.type === 'checkbox') el.blur()
          })
        }
      },
    })
    Vue.directive('hkldreset', {
      bind: function (el, binding) {
        el.addEventListener('click', function (event) {
          utils.resetDirty(deep(binding, 'value.component'))
        })
      },
    })
    Vue.directive('autosize', {
      bind: function (el, binding) {
        el.addEventListener('input', function (event) {
          scheduleRefreshSize(el, getResizeOptions(binding))
        })
      },
      inserted: function (el) {
        utils.autoresize(el)
      },
      update: function (el, binding) {
        scheduleRefreshSize(el, getResizeOptions(binding))
      },
    })
    Vue.directive('autowrap', {
      bind: function (el, binding) {
        el.addEventListener('input', function (event) {
          var inputWidth = $(event.target).textWidth(undefined, undefined, deep(binding, 'value.offset') || 0)
          $(event.target).css({
            width: inputWidth,
          })
        })
      },
      inserted: function (el, binding) {
        var inputWidth = $(el).textWidth(undefined, undefined, deep(binding, 'value.offset') || 0)
        $(el).css({
          width: inputWidth,
        })
      },
      update: function (el, binding) {
        var inputWidth = $(el).textWidth(undefined, undefined, deep(binding, 'value.offset') || 0)
        $(el).css({
          width: inputWidth,
        })
      },
    })
    Vue.directive('checkVisibility', {
      bind: function (el, binding) {
        el.addEventListener('click', function (event) {
          if (el.classList && el.classList.contains('autosize')) {
            scheduleRefreshSize(el, getResizeOptions(binding))
            return
          }
          utils.resizeElements()
        })
      },
      componentUpdated: function (el, binding) {
        if (binding.value && binding.value.refresh) {
          scheduleRefreshSize(el, getResizeOptions(binding))
        }
      },
    })
  },
}

export default InputChange
